export class TicketConsumer{
    firstName;
    lastName;
    email;
    dateOfBirth;
    address;
}